<template>
  <div class="specialist-topic" :class="{'querschnittsthema':isQuerschnittsThema}" v-if="selectedSpecialistTopic">
    <div class="row">
      <div class="large-1 columns topic-drag-handle">&#x2630;</div>
      <div class="large-2 columns icon-col">
        <img :src="selectedSpecialistTopic.icon.source" />
      </div>
      <div class="large-9 columns name">
        {{ selectedSpecialistTopic.name }}
      </div>
      <div class="large-8 columns action-buttons">
        <div class="row">
          <div
            class="large-6 columns action-button"
            @click="editSpecialistTopicStart"
            v-if="canEdit"
          >
            <i class="ig_icons dark-grey edit"></i>
            <span>{{translationHelper.getTranslation("ig_button_edit")}}</span>
          </div>
          <div v-else>&nbsp;</div>
          <div class="large-6 columns action-button" @click="toggleOffers">
            <i
              class="ig_icons dark-grey angebote"
              :class="offersExpanded ? 'open' : 'close'"
            ></i>
            <span>{{translationHelper.getTranslation("ig_title_angebote")}}</span>
          </div>
          <div
            class="large-6 columns action-button"
            @click="deleteSpecialistTopic"
            v-if="offersLoaded && settings.offers.length == 0"
          >
            <i class="ig_icons dark-grey delete"></i>
            <span>{{translationHelper.getTranslation("ig_button_delete")}}</span>
          </div>
          <div v-else class="large-6 columns action-button">&nbsp;</div>
        </div>
      </div>
    </div>
    <div class="row offers-section" v-if="offersExpanded">
      <div class="large-12 columns title-col">
        <label for="offersList" class="label">{{translationHelper.getTranslation("ig_title_angebote")}}</label>
      </div>
      <div class="large-8 columns offer-actions-col" @click="addNewOfferStart">
        <div class="add-new-wrapper">
          <i class="ig_icons white add"></i><span>{{translationHelper.getTranslation("ig_button_addnew")}}</span>
        </div>
      </div>
      <div class="large-20 columns offers-list-section">
        <div v-if="settings.offers.length === 0" class="no-offers">{{translationHelper.getTranslation("ig_error_no_agebote_found")}}</div>
        <container
          @drop="onDrop"
          id="offersList"
          class="offer-list"
          lock-axis="y"
          drag-handle-selector=".offer-drag-handle"
          :animation-duration="1000"
        >
          <draggable
            v-for="(offer, index) in settings.offers"
            :key="offer.id"
            class="offer-draggable"
          >
            <offer
              v-model="settings.offers[index]"
              :glass-item-data="glassItemData"
              :topic-id="selectedSpecialistTopic.id"
              :available-offer-types="availableOfferTypes"
              :translationHelper="translationHelper"
              @deleted="offerDeleted"
            />
          </draggable>
        </container>
      </div>
    </div>
    <template v-if="newOffer">
      <offer-edit
        v-model="newOffer"
        :show-modal="showNewOffer"
        :available-offer-types="availableOfferTypes"
        :topic-id="selectedSpecialistTopic.id"
        :glass-item-data="glassItemData"
        :translationHelper="translationHelper"
        method="save"
        @saved="offerSaved"
        @close-window="cancelAddOffer"
      />
    </template>
    <template v-if="editMode">
      <specialist-topic-edit
        v-model="selectedSpecialistTopic"
        :show-modal="editMode"
        :available-specialist-topic-icons="availableSpecialistTopicIcons"
        :glass-item-data="glassItemData"
        :translationHelper="translationHelper"
        method="update"
        @changed="specialistTopicChanged"
        @close-window="editSpecialistTopicEnd"
        @saved="specialistTopicSaved"
      />
    </template>
  </div>
</template>

<script>
import InteraktiveGrafik from "../../../../_Api/InteraktiveGrafik";
import { Container, Draggable } from "vue-smooth-dnd";
import { applyDrag } from "../../../../_Base/Utils";
import offer from "./offer.vue";
import offerEdit from "./offerEdit.vue";
import specialistTopicEdit from "./specialistTopicEdit.vue";

export default {
  components: {
    offer,
    offerEdit,
    specialistTopicEdit,
    Container,
    Draggable,
  },
  props: {
    canEdit:{ 
      type: Boolean,
      default: true
    },
    isQuerschnittsThema:{
      type: Boolean,
      default: false,
    },
    specialistTopic: {
      type: Object,
      default: () => {},
    },
    glassItemData: {
      type: Object,
      default: () => {},
    },
    availableOfferTypes: {
      type: Array,
      default: () => [],
    },
    availableSpecialistTopicIcons: {
      type: Array,
      default: () => [],
    },
    translationHelper: {
      type: Object
    },
  },
  model: {
    prop: "specialistTopic",
    event: "changed",
  },
  computed: {
    selectedSpecialistTopic: {
      get() {
        return this.specialistTopic;
      },
      set(newSpecialistTopic) {
        return newSpecialistTopic;
      },
    },
  },
  data() {
    return {
      avoidDrop:false,
      editMode: false,
      offersLoaded: false,
      offersExpanded: false,
      settings: { offers: [] },
      showNewOffer: false,
      newOffer: {
        id: "",
        shortName: "",
        linkText: "",
        url: "",
      }
    };
  },
  mounted() {
    if (!this.offersLoaded) {
      const offersByTopicQueryData = {
        ...this.glassItemData,
        ["topicId"]: this.specialistTopic.id,
      };
      InteraktiveGrafik.getOffersByTopic(offersByTopicQueryData).then(
        (response) => this.updateOffers(response)
      );
    }
  },
  methods: {
    onDrop(dropResult) {
      this.avoidDrop = true;
      var updateOffersTasks = [];
      this.settings.offers = applyDrag(
        this.settings.offers,
        dropResult
      );
      for (
        let index = 0;
        index < this.settings.offers.length;
        index++
      ) {
        if (this.settings.offers[index].sortOrder != index) {
          this.settings.offers[index].sortOrder = index;
          updateOffersTasks.push(
            this.updateOffer(
              this.settings.offers[index]
            )
          );
        }
      }
      Promise.all(updateOffersTasks).then(() => {
        this.avoidDrop = false;
      });
    },
    editSpecialistTopicStart() {
      this.editMode = true;
    },
    editSpecialistTopicEnd() {
      this.editMode = false;
    },
    specialistTopicSaved(data) {
      let specialistTopic = data.specialistTopic;
      this.selectedSpecialistTopic.icon.source = specialistTopic.icon.source;
      this.editSpecialistTopicEnd();
    },
    toggleOffers() {
      this.offersExpanded = !this.offersExpanded;
    },
    updateOffer(offer){
      return new Promise((resolve) => {
         let queryData = {
          ...this.glassItemData,
          ["offer"]:offer,
          ["topicId"]: this.specialistTopic.id,
        };
        InteraktiveGrafik.updateOffer(queryData).then(() =>{
           resolve("foo")
        })
      })
    },
    updateOffers(response) {
      this.settings.offers = response.data;
      this.offersLoaded = true;
    },
    offerDeleted(offerId) {
      let index = this.settings.offers.findIndex((x) => x.id == offerId);
      if (index >= 0) {
        this.settings.offers.splice(index, 1);
      }
    },
    specialistTopicChanged(changedTopic) {
      this.$emit("changed", changedTopic);
    },
    addNewOfferStart() {
      this.newOffer = {
        id: "",
        shortName: "",
        linkText: "",
        url: ""
      };
      var length = this.settings.offers.length
      if(length > 0){
          this.newOffer.sortOrder = this.settings.offers[length-1].sortOrder +1;
      }
      else{
        this.newOffer.sortOrder = 0
      }
      this.showNewOffer = true;
    },
    offerSaved(result) {
      if (result.status == 200) {
        this.settings.offers.push(result.offer);
      }
      this.showNewOffer = false;
    },
    cancelAddOffer() {
      this.showNewOffer = false;
    },
    deleteSpecialistTopic() {
      var msg = "Fachthema wirklich löschen?";
      var ok = confirm(msg);
      if (ok) {
        InteraktiveGrafik.deleteSpecialistTopic({
          id: this.specialistTopic.id,
        }).then((response) => this.deleted(response));
      }
    },
    deleted(response) {
      if (response.data) {
        this.$emit("deleted", this.specialistTopic.id);
      }
    }
  }
};
</script>
